import axiosInstance from './axiosInstance'
import { Case } from '../../types'
import { mockCases } from './mockData'

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const casesApi = {
  getAll: async (): Promise<Case[]> => {
    await delay(500)
    return mockCases
  },

  getById: async (id: string): Promise<Case> => {
    await delay(300)
    const c = mockCases.find((c) => c.id === id)
    if (!c) throw new Error('Case not found')
    return c
  },

  create: async (data: Omit<Case, 'id' | 'caseNumber' | 'createdAt' | 'updatedAt'>): Promise<Case> => {
    await delay(500)
    const caseNumber = `CS-${String(mockCases.length + 1).padStart(5, '0')}`
    const newCase: Case = {
      ...data,
      id: `case-${Date.now()}`,
      caseNumber,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }
    mockCases.push(newCase)
    return newCase
  },

  update: async (id: string, data: Partial<Case>): Promise<Case> => {
    await delay(500)
    const index = mockCases.findIndex((c) => c.id === id)
    if (index === -1) throw new Error('Case not found')
    mockCases[index] = {
      ...mockCases[index],
      ...data,
      updatedAt: new Date().toISOString(),
    }
    return mockCases[index]
  },

  delete: async (id: string): Promise<void> => {
    await delay(500)
    const index = mockCases.findIndex((c) => c.id === id)
    if (index === -1) throw new Error('Case not found')
    mockCases.splice(index, 1)
  },

  search: async (query: string): Promise<Case[]> => {
    await delay(300)
    return mockCases.filter(
      (c) =>
        c.subject.toLowerCase().includes(query.toLowerCase()) ||
        c.caseNumber.toLowerCase().includes(query.toLowerCase()),
    )
  },
}
